import { render } from "./VtcContinue.vue?vue&type=template&id=a17fcd4a"
import script from "./VtcContinue.vue?vue&type=script&lang=js"
export * from "./VtcContinue.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__